export const sectionData = [
    {
        id: 1,
        href: 'https://movix.ru/subscriptions/amediateka-251360',
        src: '/static/images/domru-tv/look/carousel/tv-videoteka-amedia.jpg',
        title: 'AMEDIATEKA',
        text: 'От «Троцкого» до «Декстера». Сериалы, о которых говорят все — в одной подписке.',
        cost: '349 ₽/мес',
    },
    {
        id: 2,
        href: 'https://movix.ru/subscriptions/megogo_kino-333466',
        src: '/static/images/domru-tv/look/carousel/tv-videoteka-megogo.jpg',
        title: 'MEGOGO Кино',
        text: 'Советская классика и зарубежные новинки. Более 5000 боевиков, комедий и мелодрам.',
        cost: '150 ₽/мес',
    },
    {
        id: 3,
        href: 'https://movix.ru/subscriptions/more_d-301128',
        src: '/static/images/domru-tv/look/carousel/608_277%D1%80%D0%B5%D0%B4.jpg',
        title: 'More D',
        text: 'Лучшие шоу канала Discovery. Об удивительных животных и загадочных людях.',
        cost: '99 ₽/мес',
    },
    {
        id: 4,
        href: 'https://movix.ru/subscriptions/detam-293315',
        src: '/static/images/domru-tv/look/carousel/tv-videoteka-detyam.jpg',
        title: 'Детям',
        text: 'Русские и зарубежные мультики. Приучайте детей к хорошим фильмам сразу.',
        cost: '179 ₽/мес',
    },
];
